import { useEffect, useState } from 'react'
import { PrivateLessonConfig } from '../../../pure-js/types/GrooverTypes'
import { getPrivateLessonConfig } from '../libs/CloudFunctionsApiHandler'

export const usePrivateLessonConfig = (clientId: string | null) => {
  const [config, setConfig] = useState<PrivateLessonConfig | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!clientId) return

    setLoading(true)
    getPrivateLessonConfig({ clientId })
      .then((result) => {
        setConfig(result)
        setError(null)
      })
      .catch((err) => {
        setError(err?.message || 'Failed to load configuration')
        setConfig(null)
      })
      .finally(() => setLoading(false))
  }, [clientId])

  return { config, loading, error }
}
